import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { Responsive, Grid } from 'semantic-ui-react';
import Step from './Step';

const Container = styled.div`
  background-color: #7b4bf6;
  padding: 60px 20px 20px 20px;
  color: #ffffff;
  text-align: center;
`;

const Box = styled.div`
  max-width: 1024px;
  margin: 0 auto;
`;

const steps = [
  {
    step: 1,
    descrption:
      'Schedule an upcoming show and record a show trailer clip in our app'
  },
  {
    step: 2,
    descrption:
      'An assistant host will reach out to help guide you in your store set up'
  },
  {
    step: 3,
    descrption: 'Prepare products to go live with'
  },
  {
    step: 4,
    descrption: 'Assistant goes live and helps sells your product'
  },
  {
    step: 5,
    descrption:
      'Receive post-show wrap up reports outlining  key stats of sales and engagement'
  },
  {
    step: 6,
    descrption:
      'Package and ship orders using shipping labels provided by Popshop'
  }
];

export default () => {
  return (
    <Container>
      <Box>
        <h2 className="title">Here’s How a Show Works</h2>
        <p className="step-description">
          We think your brand would be a great fit for Popshop Live. We only
          partner with brands that our expert influencers have personally
          selected and are willing to put their names behind. That translates to
          an audience of dedicated and passionate shoppers eager to buy the
          products endorsed by their favorite creators.
        </p>
        <Responsive minWidth={641}>
          <Grid>
            {_.map(_.chunk(steps, 2), (row, index) => {
              return (
                <Grid.Row key={index} columns={2}>
                  <Grid.Column>
                    <Step step={row[0].step} descrption={row[0].descrption} />
                  </Grid.Column>
                  <Grid.Column>
                    <Step step={row[1].step} descrption={row[1].descrption} />
                  </Grid.Column>
                </Grid.Row>
              );
            })}
          </Grid>
        </Responsive>
        <Responsive maxWidth={640}>
          {steps.map(({ step, descrption }) => {
            return <Step key={step} step={step} descrption={descrption} />;
          })}
        </Responsive>
      </Box>
    </Container>
  );
};
